import { DataType } from '../../../../components/tablesConfig/filterconfig'
import { IFlags } from '../../../../components/singleObject'
import * as actions from './actions'
import { Actions } from './actions'
import { ConsoleSqlOutlined } from '@ant-design/icons'

export type State = {
  data?: DataType[]
  singleData?: IFlags
  loading: boolean
}

const initialState: State = {
  data: [],
  singleData: { namn: '', flaggor: [] },
  loading: true,
}

const caseReducer = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case actions.LOADING_CASE:
      return (state = {
        ...state,
        loading: action.payload.loading,
      })
    case actions.SET_CASE:
      return (state = {
        ...state,
        data: action.payload.data,
        singleData: action.payload.singleData,
      })
    default:
      return state
  }
}

export default caseReducer
